<script setup lang="ts">
import { computed, nextTick, onMounted, ref, watch } from 'vue'
import brandMark from '~/assets/images/logo_gray.png'
import appLogo from '~/assets/images/app_logo.png'
import fallbackMark from '~/assets/images/music-fallback-transparent.png'
import { isDefaultMusicCover } from '~/utils/music-cover'
const props = withDefaults(defineProps<{ src?: string; srcset?: string; sizes?: string; fetchpriority?: 'high' | 'low' | 'auto'; alt: string; hue?: number; width?: number; height?: number; loading?: 'lazy' | 'eager' }>(), { hue: 152, width: 320, height: 320, loading: 'lazy' })
const hue = computed(() => Number.isFinite(props.hue) ? ((props.hue % 360) + 360) % 360 : 152)
const image = ref<HTMLImageElement | null>(null)
const hasError = ref(false)
const sourceKey = computed(() => JSON.stringify([props.src, props.srcset]))
const fallback = computed(() => !props.src?.trim() || hasError.value || isDefaultMusicCover(props.src) || props.src === brandMark || props.src === appLogo || props.src === fallbackMark)
const checkCachedImage = () => {
  if (image.value?.complete && image.value.naturalWidth === 0) hasError.value = true
}
const onError = (event: Event) => {
  if (event.currentTarget === image.value) hasError.value = true
}
watch(sourceKey, () => { hasError.value = false; void nextTick(checkCachedImage) }, { flush: 'sync' })
watch(image, checkCachedImage, { flush: 'post' })
onMounted(checkCachedImage)
</script>

<template>
  <div class="cover" :class="{ 'mm-cover-fallback': fallback }" :style="{ '--cover-h': hue }" :role="fallback && alt ? 'img' : undefined" :aria-label="fallback && alt ? alt : undefined" :aria-hidden="fallback && !alt ? true : undefined">
    <img v-if="fallback" class="mm-cover-mark" :src="fallbackMark" alt="" :width="width" :height="height" decoding="async">
    <img v-else :key="sourceKey" ref="image" :src="src" :srcset="srcset" :sizes="sizes" :fetchpriority="fetchpriority" :alt="alt" :width="width" :height="height" :loading="loading" decoding="async" @error="onError">
  </div>
</template>

<style scoped>
.cover.mm-cover-fallback { display: grid; place-items: center; background: var(--surface-2); }
.cover.mm-cover-fallback > .mm-cover-mark { width: 100%; height: 100%; object-fit: contain; }
</style>
